













































import Vue from "vue";
import data from "@/data/videos";
import Video from "@/models/Video";

export default Vue.extend({
  created() {
    const initialData = data;
    Video.insert({ data: initialData });
  },

  computed: {
    videos(): Video[] {
      return Video.query().orderBy("pos", "desc").get() || [];
    },
  },

  methods: {
    resetScrollToContainerTop(): void {
      const container: HTMLElement | null =
        document?.querySelector(".container");
      if (container) {
        container.scrollTop = 0;
      }
    },
  },

  mounted() {
    this.resetScrollToContainerTop();
  },
});
